import React from "react";
import {BECKEND_PATH} from '../../config';

import RadioButton from "./components/RadioButtons";
import RadioButtonsImage from "./components/RadioButtonsImage";
import Modal from '../Modal/Modal';

import "./WycenaEtykietSection.scss";
import { Link } from "react-router-dom";

export default class WycenaEtykietSection extends React.Component {

  state = {
    selected: {
      name: '',
      company: '',
      phone: '',
      mail: '',
      naklad: '',
      wymiarSzer: '',
      wymiarWys: '',
      laminowanie: 'nie',
      laminat: 'mat',
      ksztalt: 'standard',
      podloze: 'folia błysk',
      nawoj: 'zewnatrz_prawy',
      message: '',
      typ: this.props.type === "expirienced" ? 'rolka' : 'arkusz',
      fileId: null
    },
    status: null,
    honey: '',
    isModalOpen: false
  }

  clickHandler = async (event) => {
    event.preventDefault();
    this.setState({
        status: 'loading'
    })

    const {
      name,
      company,
      phone,
      mail,
      naklad,
      wymiarSzer,
      wymiarWys,
      laminowanie,
      laminat,
      ksztalt,
      podloze,
      nawoj,
      message,
      typ,
      fileId
    } = this.state.selected;

    const status = await fetch(BECKEND_PATH + 'cost-form.php', {
        headers: {
            'Content-Type': 'application/json',
          },
          method: 'POST',
          body: JSON.stringify({
            name,
            company,
            phone,
            mail,
            naklad,
            wymiarSzer,
            wymiarWys,
            laminowanie,
            laminat,
            ksztalt,
            podloze,
            nawoj,
            message,
            typ,
            honey: this.state.honey,
            fileId
        })
        
      }).then(res => res.json()).then(res => res.status);

      console.log(status)

      if(status === 'ok') {
        this.setState({
            status: 'done'
        });

        setTimeout(() => {
            this.setState({
              selected: {
                name: '',
                company: '',
                phone: '',
                mail: '',
                naklad: '',
                wymiarSzer: '',
                wymiarWys: '',
                laminowanie: 'nie',
                laminat: 'mat',
                ksztalt: 'standard',
                podloze: 'folia błysk',
                nawoj: 'zewnatrz_prawy',
                message: '',
                typ: this.props.type === "expirienced" ? 'rolka' : 'arkusz',
                fileId: null
              },
              status: null,
              honey: ''
            })
        }, 2000)
      } else if(status === 'error') {
          this.setState({
            status: 'error'
          });
      }
}

  changeSelected(key, value) {
    this.setState({
      ...this.state,
      selected: {
        ...this.state.selected,
        [key]: value
      }
    })
  }

  upload(file) {
    var data = new FormData();
    
    data.append('plik', file)

    this.setState({
      status: 'load file'
    });

    fetch(BECKEND_PATH+'upload.php', { // Your POST endpoint
      method: 'POST',
      body: data // This is your file object
    }).then(
      response => response.json() // if the response is a JSON object
    ).then(
      response => {
        console.log(response)
        this.setState({
        selected: {
          ...this.state.selected,
          fileId: response.id
        },
        status: 'file uploaded',
        isModalOpen: true
      });
     } // Handle the success response object
    ).catch(
      error => console.log(error) // Handle the error response object
    );
  }

  getModals() {
    if(this.state.isModalOpen) {
      switch(this.state.status) {
        case 'file uploaded':
          console.log('wlazlem tu')
        return <Modal
          isOpen={true}
          closeButtonText="Zamknij okno"
          closeCallback={
            () => {
              this.setState({
                isModalOpen: false
              })
            }
          }
        >
          Plik został zaimportowany pomyślnie
        </Modal>
      }
    }
  }

  render() {
    return (
      <div className="theme-grey wycena-etykiet">
        {this.getModals()}
        <div className="container">
          <div className="row">
            <h2>{this.props.title}</h2>
            <div className="col-12 col-md-6">
              <p>
                Zaufaj naszemu doświadczeniu, skontaktuj się z nami korzystając
                z poniższego formularza:
              </p>
            </div>
            <div className="offset-md-6"></div>
            <div className="col-12">
              <u>Dane kontaktowe:</u>
            </div>
            <div className="col-12">
              <div className="row">
                <div className="col-12 col-md-6">
                  <input
                    value={this.state.selected.name}
                    type="text"
                    placeholder="Imię i Nazwisko"
                    onChange={(event) => this.changeSelected('name', event.target.value)}
                  />
                </div>
                <div className="col-12 col-md-6">
                  <input
                    value={this.state.selected.company}
                    type="text"
                    placeholder="firma"
                    onChange={(event) => this.changeSelected('company', event.target.value)}
                  />
                </div>
              </div>
            </div>

            <div className="col-12">
              <div className="row">
                <div className="col-12 col-md-6">
                  <input
                    value={this.state.selected.phone}
                    type="text"
                    placeholder="numer telefonu"
                    onChange={(event) => this.changeSelected('phone', event.target.value)}
                  />
                </div>
                <div className="col-12 col-md-6">
                  <input
                    value={this.state.selected.mail}
                    type="text"
                    placeholder="e-mail"
                    onChange={(event) => this.changeSelected('mail', event.target.value)}
                  />
                </div>
              </div>
            </div>

            <div className="col-12">
              <u>Dane do wyceny:</u>
              <div className="row">
                <div className="col-12 col-lg-6">
                  <div className="row">
                    <div className="col-12 col-md-6">
                      <label>nakład</label>
                      <input
                        value={this.state.selected.naklad}
                        type="text"
                        placeholder="ilość"
                        onChange={(event) => this.changeSelected('naklad', event.target.value)}
                      />
                    </div>
                    <div className="col-12 col-md-6 two-input">
                      <label>wymiar etykiet</label>
                      <input
                        value={this.state.selected.wymiarSzer}
                        type="text"
                        placeholder="szer"
                        onChange={(event) => this.changeSelected('wymiarSzer', event.target.value)}
                      />
                      <span>x</span>
                      <input
                        value={this.state.selected.wymiarWys}
                        type="text"
                        placeholder="wys"
                        onChange={(event) => this.changeSelected('wymiarWys', event.target.value)}
                      />
                    </div>
                    <div className="col-12 col-md-6 two-input">
                      <label>laminowanie</label>
                      <RadioButton
                        changeChoice={(value) => this.changeSelected('laminowanie', value)}
                        value={this.state.selected.laminowanie}
                        options={[
                          "nie",
                          "tak"
                        ]}
                        className="col-6"
                        parentClassName="row"
                      />
                    </div>
                    <div className="col-12 col-md-6 two-input">
                      <label>laminat</label>
                      <RadioButton
                        changeChoice={(value) => this.changeSelected('laminat', value)}
                        value={this.state.selected.laminat}
                        options={[
                          "mat",
                          "błysk"
                        ]}
                        className="col-6"
                        parentClassName="row"
                      />
                    </div>
                    <div className="col-12 two-input">
                      <label>kształt etykiety</label>
                      <RadioButton
                        changeChoice={(value) => this.changeSelected('ksztalt', value)}
                        value={this.state.selected.ksztalt}
                        options={[
                          {name: 'standard', label: 'KWADRAT / PROSTOKĄT / KOŁO / OKRĄG'},
                          {name: 'nietypowy', label: 'ZAŁĄCZ W PLIKU LINIE CIĘCIA'}
                        ]}
                        className="col-6"
                        parentClassName="row"
                      />
                    </div>
                  </div>
                </div>
                <div className="col-12 col-lg-6">
                  <label>podłoże</label>
                      <RadioButton
                        changeChoice={(value) => this.changeSelected('podloze', value)}
                        value={this.state.selected.podloze}
                        options={this.props.type === 'expirienced' ? [
                          "folia błysk", "folia mat", "folia transparent", "ExtraGrip", "papier błysk"
                        ] : [
                          "folia błysk", "folia mat", "papier błysk", "papier mat", "srebrna folia", {name: "inne", label: "DOSTĘPNE NA ZAMÓWIENIE"},
                        ]}
                        className="col-6"
                        parentClassName="row multi-container"
                      />
                </div>
              </div>
            </div>
            {
              this.props.type === "expirienced" &&
              <div className="col-12">
                <label>sposób nawoju etykiet</label>
                <RadioButtonsImage
                  changeChoice={(value) => this.changeSelected('nawoj', value)}
                  value={this.state.selected.nawoj}
                  prefix="form_"
                  options={[
                    "zewnatrz_prawy",
                    "zewnatrz_lewy",
                    "zewnatrz_spod",
                    "zewnatrz_gora",
                    "srodek_prawy",
                    "srodek_lewy",
                    "srodek_spod",
                    "srodek_gora",
                  ]}
                  className="col-12"
                  parentClassName="row radio-buttons-image-container"
                />
              </div>
            }
            <div className="col-12">
              <textarea placeholder="uwagi" onChange={(event) => this.changeSelected('message', event.target.value)}></textarea>
            </div>
            <div className="col-12 text-end buttons">
              <Link to="/faq">Jak przygotować plik?</Link>
              <Link to="/faq"><button>FAQ</button></Link>
          <label for="plik" className="button">{this.state.status === 'file uploaded' ? 'Plik załadowany' : 'Wgraj plik'}</label>
              <input type="file" id="plik" name="plik" onChange={(e) => this.upload(e.target.files[0])}/>
              <button onClick={this.clickHandler}>wyślij</button>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
